import { memo } from 'react';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/SearchRounded';

const Search = ({ value, onChange }) => {
  return (
    <TextField
      fullWidth
      placeholder='Search'
      variant='standard'
      InputProps={{
        disableUnderline: true,
        startAdornment: <SearchIcon sx={{ color: 'primary.main', fontSize: '1.5rem', mr: .5 }} />,
      }}
      value={value}
      onChange={({ target: { value } }) => onChange(value)}
    />
  );
}

export default memo(Search);